import {getMethod} from '@/api'

export const get = request => getMethod('/api/orderHistory', request)
